<template>
    <layout-bigscreen nav_top="0">
        <div id="antdVue" ref="antdVue" :style="themeColorInit(themeColorConfig)" class="zoom_bg_color" style="width:100%; height:100%;">
            <div class="antdVue" :style="{...calculateStyles}">

                <div class="flex flex-direction justify-center benben-flex-layout gongzuotaiwai_987_random_flex_0 pd-t-0 pd-r-0 pd-b-20 pd-l-0 w-100">
                    <div class="flex flex-wrap align-center justify-center gongzuotaiwai_810_fd0_0 mg-t-0 mg-r-0 mg-b-10 mg-l-0 pd-t-0 pd-r-0 pd-b-20 pd-l-0 w-100 f-c-3 position-relative bg-size-auto">
                        <div class="flex  flex-wrap align-center gongzuotaiwai_118_fd0_0_c0 position-absolute">
                            <img class='gongzuotaiwai_863_fd0_0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/03e56738af5b3ecc593d3c6c58203cc6.png" />
                            <span class="gongzuotaiwai_458_fd0_0_c0_c1 t-20 t-w-4">多云</span>
                            <div class="flex  flex-wrap align-center gongzuotaiwai_407_fd0_0_c0_c2 bg-size-auto">

                            </div>
                            <span class="gongzuotaiwai_432_fd0_0_c0_c3 t-20 h-10-px t-w-4">6</span>
                            <span class="gongzuotaiwai_432_fd0_0_c0_c3 t-20 h-10-px t-w-4">℃</span>

                        </div>
                        <img class='gongzuotaiwai_465_fd0_0_c1' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/e86a55b2a20775c71c1fb6cc91dd3c1e.png" />
                        <span class="mg-t-0 mg-r-0 mg-b-10 mg-l-0">实时交易驾驶舱</span>
                        <img class='gongzuotaiwai_912_fd0_0_c3' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/d3adc8fbbce7c9aa2bbd0f8ae8ac5a40.png" />
                        <div class="flex align-center gongzuotaiwai_300_fd0_0_c4 position-absolute">
                            <img class='gongzuotaiwai_787_fd0_0_c4_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/2af63761ef0068fdbbfded13de1d740c.png" />

                            <benben-real-time class='flex align-center justify-center gongzuotaiwai_596_random_fd0_0_c4_c1 t-18 t-w-4' format="YYYY-MM-DD HH:mm:ss" :has_week="true" :refresh_interval="500" show_title="true" title_position="left" title_name="标题">

                            </benben-real-time>


                        </div>

                        <benben-full-screen class='flex align-center justify-center gongzuotaiwai_943_random_fd0_0_c5 position-absolute a'>

                        </benben-full-screen>


                    </div>

                    <a-row class="benben-grid   w-100" :gutter="[8,8]" type="flex">

                        <a-col :xs="24" :md="6" :xl="6" :xxl="6">
                            <div class="flex  flex-wrap align-center  pd-t-0 pd-r-0 pd-b-0 pd-l-10 w-100">
                                <div class="flex flex-direction align-start gongzuotaiwai_845_fd0_1_c0_c0_c0 w-100 bg-size-auto">
                                    <div class="flex flex-wrap align-center gongzuotaiwai_967_fd0_1_c0_c0_c0_c0 w-100">
                                        <span class="gongzuotaiwai_918_fd0_1_c0_c0_c0_c0_c0 f-c-fff t-20">商品分类占比</span>

                                    </div>
                                    <div class="flex flex-direction flex-wrap align-start gongzuotaiwai_278_fd0_1_c0_c0_c0_c1 w-100 position-relative">
                                        <img class='gongzuotaiwai_237_fd0_1_c0_c0_c0_c1_c0 mg-t-0 mg-r-0 mg-b-10 mg-l-0 w-100' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240304/6f8e36626048ee53a10b0bd80cf67679.png" />

                                    </div>
                                    <div class="flex flex-wrap align-center justify-center  w-100 position-relative h-100">
                                        <img class='gongzuotaiwai_906_fd0_1_c0_c0_c0_c2_c0 position-absolute' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240311/27015dfd68c9221791c42af8c7d0eb17.png" />
                                        <div class="flex flex-direction align-center gongzuotaiwai_830_fd0_1_c0_c0_c0_c2_c1 position-absolute">

                                            <benben-light-text class='light-text gongzuotaiwai_380_random_fd0_1_c0_c0_c0_c2_c1_c0 f-c-fff t-36' :field-options="orderAmount" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                            </benben-light-text>

                                            <span class="gongzuotaiwai_832_fd0_1_c0_c0_c0_c2_c1_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 f-c-fff t-16 t-w-5">支付订单金额</span>

                                        </div>

                                        <benben-pie-ring class='w-100 h-100' :field-options="catePie" data_source_type="1" chart_show_type="pie-ring" show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_8404" :chart-option="chartOptions_random_1923">

                                        </benben-pie-ring>


                                    </div>

                                </div>
                                <div class="flex flex-direction align-start gongzuotaiwai_247_fd0_1_c0_c0_c1 w-100 bg-size-auto">
                                    <span class="gongzuotaiwai_510_fd0_1_c0_c0_c1_c0 f-c-fff t-22">地域分布</span>
                                    <img class='gongzuotaiwai_633_fd0_1_c0_c0_c1_c1 w-100' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240304/6f8e36626048ee53a10b0bd80cf67679.png" />
                                    <div class="flex  flex-wrap align-center  w-100">

                                        <benben-area-map class='gongzuotaiwai_791_random_fd0_1_c0_c0_c1_c2_c0 w-100' :field-options="orderAddressMap" data_source_type="1" chart_show_type="area-map" show_title="false" title_position="center" title_name="标题" :theme_color="theme_color_5461" :hide_rank="true">

                                        </benben-area-map>


                                    </div>

                                </div>

                            </div>

                        </a-col>


                        <a-col :xs="24" :md="12" :xl="12" :xxl="12">
                            <div class="flex flex-direction align-center self-center  w-100 h-100 position-relative">
                                <div class="flex flex-wrap align-start justify-center gongzuotaiwai_610_fd0_1_c1_c0_c0 w-100 position-relative">
                                    <div class="flex flex-direction align-start  w-100">
                                        <div class="flex align-center justify-between gongzuotaiwai_777_fd0_1_c1_c0_c0_c0_c0 mg-t-10 mg-r-0 mg-b-0 mg-l-0 w-100">
                                            <div class="flex flex-direction flex-wrap align-center justify-center gongzuotaiwai_233_fd0_1_c1_c0_c0_c0_c0_c0 h-100 bg-size-auto">

                                                <benben-light-text class='light-text gongzuotaiwai_623_random_fd0_1_c1_c0_c0_c0_c0_c0_c0 f-c-fff t-36' :field-options="goodsCount" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>

                                                <span class="gongzuotaiwai_623_random_fd0_1_c1_c0_c0_c0_c0_c0_c0 mg-t-10 mg-r-0 mg-b-0 mg-l-0 f-c-fff t-18">成交商品</span>

                                            </div>
                                            <div class="flex flex-direction flex-wrap align-center justify-center gongzuotaiwai_233_fd0_1_c1_c0_c0_c0_c0_c0 h-100 bg-size-auto">

                                                <benben-light-text class='light-text gongzuotaiwai_623_random_fd0_1_c1_c0_c0_c0_c0_c0_c0 f-c-fff t-36' :field-options="goodsViewCount" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>

                                                <span class="gongzuotaiwai_623_random_fd0_1_c1_c0_c0_c0_c0_c0_c0 mg-t-10 mg-r-0 mg-b-0 mg-l-0 f-c-fff t-18">浏览量</span>

                                            </div>

                                        </div>
                                        <div class="flex align-center justify-between gongzuotaiwai_838_fd0_1_c1_c0_c0_c0_c1 mg-t-50 mg-r-0 mg-b-0 mg-l-0 pd-t-0 pd-r-30 pd-b-0 pd-l-30 w-100">
                                            <div class="flex flex-direction flex-wrap align-center justify-center gongzuotaiwai_233_fd0_1_c1_c0_c0_c0_c0_c0 h-100 bg-size-auto">

                                                <benben-light-text class='light-text gongzuotaiwai_623_random_fd0_1_c1_c0_c0_c0_c0_c0_c0 f-c-fff t-36' :field-options="orderCount" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>

                                                <span class="gongzuotaiwai_623_random_fd0_1_c1_c0_c0_c0_c0_c0_c0 mg-t-10 mg-r-0 mg-b-0 mg-l-0 f-c-fff t-18">成交客户</span>

                                            </div>
                                            <div class="flex flex-direction align-center justify-center gongzuotaiwai_233_fd0_1_c1_c0_c0_c0_c0_c0 h-100 bg-size-auto">

                                                <benben-light-text class='light-text gongzuotaiwai_623_random_fd0_1_c1_c0_c0_c0_c0_c0_c0 f-c-fff t-36' :field-options="goodsViewCount" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>

                                                <span class="gongzuotaiwai_623_random_fd0_1_c1_c0_c0_c0_c0_c0_c0 mg-t-10 mg-r-0 mg-b-0 mg-l-0 f-c-fff t-18">访客数</span>

                                            </div>

                                        </div>
                                        <div class="flex flex-direction flex-wrap align-center justify-center gongzuotaiwai_570_fd0_1_c1_c0_c0_c0_c2 w-100 f-c-fff t-40 position-absolute">
                                            <span>销售额</span>

                                            <benben-light-text class='light-text gongzuotaiwai_623_random_fd0_1_c1_c0_c0_c0_c0_c0_c0 f-c-fff t-36' :field-options="payAmount" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                            </benben-light-text>


                                        </div>
                                        <div class="flex align-center justify-between gongzuotaiwai_838_fd0_1_c1_c0_c0_c0_c1 mg-t-50 mg-r-0 mg-b-0 mg-l-0 pd-t-0 pd-r-20 pd-b-0 pd-l-30 w-100">
                                            <div class="flex flex-direction flex-wrap align-center justify-center gongzuotaiwai_233_fd0_1_c1_c0_c0_c0_c0_c0 h-100 bg-size-auto">

                                                <benben-light-text class='light-text gongzuotaiwai_623_random_fd0_1_c1_c0_c0_c0_c0_c0_c0 f-c-fff t-36' :field-options="customerPrice" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>

                                                <span class="gongzuotaiwai_623_random_fd0_1_c1_c0_c0_c0_c0_c0_c0 mg-t-10 mg-r-0 mg-b-0 mg-l-0 f-c-fff t-18">均单价</span>

                                            </div>
                                            <div class="flex flex-direction flex-wrap align-center justify-center gongzuotaiwai_233_fd0_1_c1_c0_c0_c0_c0_c0 h-100 bg-size-auto">

                                                <benben-light-text class='light-text gongzuotaiwai_623_random_fd0_1_c1_c0_c0_c0_c0_c0_c0 f-c-fff t-36' :field-options="customerPrice" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>

                                                <span class="gongzuotaiwai_623_random_fd0_1_c1_c0_c0_c0_c0_c0_c0 mg-t-10 mg-r-0 mg-b-0 mg-l-0 f-c-fff t-18">客单价</span>

                                            </div>

                                        </div>

                                    </div>

                                </div>
                                <div class="flex flex-direction align-start gongzuotaiwai_228_fd0_1_c1_c0_c1 w-100 bg-size-auto">
                                    <span class="gongzuotaiwai_510_fd0_1_c0_c0_c1_c0 f-c-fff t-22">今日销量</span>
                                    <img class='gongzuotaiwai_633_fd0_1_c0_c0_c1_c1 w-100' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240311/f10f2f81d8c917a16d8087ab40bd4b8d.png" />
                                    <div class="flex align-center justify-center gongzuotaiwai_813_fd0_1_c1_c0_c1_c2 w-100">
                                        <div class="flex flex-direction flex-wrap align-center justify-center gongzuotaiwai_127_fd0_1_c1_c0_c1_c2_c0 w-100 bg-size-auto lh-24-px f-c-fff t-16 t-w-5 h-100">
                                            <span class="mg-t-0 mg-r-0 mg-b-10 mg-l-0">下单数</span>
                                            <div class="flex flex-wrap align-center justify-center  w-100">

                                                <benben-light-text class='light-text gongzuotaiwai_895_random_fd0_1_c1_c0_c1_c2_c0_c1_c0 t-32 t-w-4' :field-options="goodsCountToday" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>

                                                <span class="gongzuotaiwai_842_fd0_1_c1_c0_c1_c2_c0_c1_c1 t-20 t-w-4">单</span>

                                            </div>

                                        </div>
                                        <div class="flex flex-direction flex-wrap align-center justify-center gongzuotaiwai_127_fd0_1_c1_c0_c1_c2_c0 w-100 bg-size-auto lh-24-px f-c-fff t-16 t-w-5 h-100">
                                            <span class="mg-t-0 mg-r-0 mg-b-10 mg-l-0">付款单量</span>
                                            <div class="flex flex-wrap align-center justify-center  w-100">

                                                <benben-light-text class='light-text gongzuotaiwai_895_random_fd0_1_c1_c0_c1_c2_c0_c1_c0 t-32 t-w-4' :field-options="orderCountToday" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>

                                                <span class="gongzuotaiwai_842_fd0_1_c1_c0_c1_c2_c0_c1_c1 t-20 t-w-4">单</span>

                                            </div>

                                        </div>
                                        <div class="flex flex-direction flex-wrap align-center justify-center gongzuotaiwai_127_fd0_1_c1_c0_c1_c2_c0 w-100 bg-size-auto lh-24-px f-c-fff t-16 t-w-5 h-100">
                                            <span class="mg-t-0 mg-r-0 mg-b-10 mg-l-0">付款客户</span>
                                            <div class="flex flex-wrap align-center justify-center  w-100">

                                                <benben-light-text class='light-text gongzuotaiwai_895_random_fd0_1_c1_c0_c1_c2_c0_c1_c0 t-32 t-w-4' :field-options="orderUserCountToday" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>

                                                <span class="gongzuotaiwai_842_fd0_1_c1_c0_c1_c2_c0_c1_c1 t-20 t-w-4">人</span>

                                            </div>

                                        </div>
                                        <div class="flex flex-direction flex-wrap align-center justify-center gongzuotaiwai_209_fd0_1_c1_c0_c1_c2_c3 w-100 bg-size-auto lh-24-px f-c-fff t-16 t-w-5 h-100">
                                            <span class="mg-t-0 mg-r-0 mg-b-10 mg-l-0">下单支付率</span>
                                            <div class="flex flex-wrap align-center justify-center  w-100">

                                                <benben-light-text class='light-text gongzuotaiwai_895_random_fd0_1_c1_c0_c1_c2_c0_c1_c0 t-32 t-w-4' :field-options="payRate" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>

                                                <span class="gongzuotaiwai_842_fd0_1_c1_c0_c1_c2_c0_c1_c1 t-20 t-w-4">%</span>

                                            </div>

                                        </div>

                                    </div>
                                    <div class="flex  flex-wrap align-center  w-100 h-100">

                                        <benben-line-simple class='gongzuotaiwai_431_random_fd0_1_c1_c0_c1_c3_c0 w-100' :field-options="orderAmountLine" data_source_type="1" chart_show_type="line-simple" show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_8560" :chart-option="chartOptions_random_4677">

                                        </benben-line-simple>


                                    </div>

                                </div>

                            </div>

                        </a-col>


                        <a-col :xs="24" :md="6" :xl="6" :xxl="6">
                            <div class="flex  flex-wrap align-center  w-100">
                                <div class="flex flex-direction align-start gongzuotaiwai_327_fd0_1_c2_c0_c0 w-100 bg-size-auto">
                                    <span class="gongzuotaiwai_510_fd0_1_c0_c0_c1_c0 f-c-fff t-22">实时订单</span>
                                    <img class='gongzuotaiwai_237_fd0_1_c0_c0_c0_c1_c0 mg-t-0 mg-r-0 mg-b-10 mg-l-0 w-100' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240304/6f8e36626048ee53a10b0bd80cf67679.png" />
                                  <div class="flex  flex-wrap align-center lianmengfenxidaping_217_fd0_1_c0_c0_c0_c1 w-100 bg-size-auto">
                                  </div>
                                  <div class="flex flex-wrap align-center flex-sub  w-100">

                                        <big-screen-custom-table class='gongzuotaiwai_568_random_fd0_1_c2_c0_c0_c2_c0 t-14 f-c-fff' :field-options="goodsRankList" data_source_type="1" chart_show_type="big_screen_table" :new_width="true" width="100%" height="100%" :show_num="10" sort_order="desc" sort_field="num" sort_name="排名" :sort_width="10" select_field="" :show_progress="false" :theme_color="theme_color_8123" play_type="all_num" :interval="5" :delay="3" :show_header="true" :head_height="40" :row_gutter="0" :column_config="[]" :show_pictorial="false">
                                            <div class="flex align-center self-center justify-center  w-100 h-100" slot="one">
                                                <img class='gongzuotaiwai_654_fd0_1_c2_c0_c0_c2_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/07410c01c6b5f0a1e2d49e5a5727e547.png" />

                                            </div>
                                            <div class="flex align-center self-center justify-center  w-100 h-100" slot="two">
                                                <img class='gongzuotaiwai_654_fd0_1_c2_c0_c0_c2_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/bf1b79a1af40a4037a7c575736bd7300.png" />

                                            </div>
                                            <div class="flex align-center self-center justify-center  w-100 h-100" slot="three">
                                                <img class='gongzuotaiwai_654_fd0_1_c2_c0_c0_c2_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/9c17908cf8ecccd852a1956e9c3f7f2e.png" />

                                            </div>
                                            <template v-slot:other="{index}">
                                                <div class="flex align-center self-center justify-center  w-100 h-100 t-14">
                                                    <div class="flex flex justify-center align-center">
                                                        <span>{{index}}</span>

                                                    </div>

                                                </div>
                                            </template>

                                        </big-screen-custom-table>


                                    </div>

                                </div>
                                <div class="flex flex-direction align-start gongzuotaiwai_231_fd0_1_c2_c0_c1 w-100 bg-size-auto">
                                    <span class="gongzuotaiwai_510_fd0_1_c0_c0_c1_c0 f-c-fff t-22">售后分析</span>
                                    <img class='gongzuotaiwai_237_fd0_1_c0_c0_c0_c1_c0 mg-t-0 mg-r-0 mg-b-10 mg-l-0 w-100' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240304/6f8e36626048ee53a10b0bd80cf67679.png" />
                                    <div class="flex  flex-wrap align-center  w-100">

                                        <benben-bar-base class='gongzuotaiwai_473_random_fd0_1_c2_c0_c1_c2_c0 w-100' :field-options="refundAmountLine" data_source_type="1" chart_show_type="bar-base" show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_2141" :chart-option="chartOptions_random_3271">

                                        </benben-bar-base>


                                    </div>
                                    <div class="flex  flex-wrap align-center  w-100">

                                        <benben-line-simple class='gongzuotaiwai_473_random_fd0_1_c2_c0_c1_c2_c0 w-100' :field-options="field_options_569372" data_source_type="1" chart_show_type="line-simple" show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_7982" :chart-option="chartOptions_random_3375">

                                        </benben-line-simple>


                                    </div>

                                </div>

                            </div>

                        </a-col>


                    </a-row>


                </div>

            </div>
        </div>
    </layout-bigscreen>
</template>
<script>
    import {
        bigScreenMixins,
        receiveNew
    } from '@/assets/diypaaspc/diy-generate-big-screen-new.js'
    import {
        receive,
        benbenSelectDiy,
        benbenFlexNumberBox,
        scrollList,
        treeSelect,
        simpleSelect,
        multipleSelect,
        cascaderForm,
        checkboxForm,
        switchForm,
        messageReply,
        rangePicker,
        handSignature,
        mixinAddTableItem,
        editorForm,
        qiunDataCharts,
        copyText,
        mixinTableItemChange,
        in_array,
        themeColorInit,
        getUrlKey,
        clearDataPass,
        isEmpty,
        treeEdit
    } from '@/assets/diypaaspc/diy-pass-pc.js'
    import {
        provinceForm
    } from '@/assets/diypaaspc/province_area.js'
    import request from '@/utils/request'
    import * as echarts from 'echarts'
    import 'echarts-gl'
    import 'echarts-liquidfill'
    import {
        mapdata
    } from '@/assets/diypaaspc/mapdata.js'
    import layoutBigscreen from "@/components/layoutBigscreen"
    import {goodsResult, homeAllResult, homeResult} from "@/api/statistics/home";
    import {goodsCateAmountPie, goodsCatePie} from "@/api/statistics/goods";
    import {orderAmountChart} from "@/api/statistics/order";
    import {pageGoods} from "@/api/finance/goods";
    import moment from 'moment';
    import {userAddressOrder} from "@/api/statistics/user";

    export default {
        name: 'gongzuotaiwai',
        components: {
            layoutBigscreen
        },
        mixins: [bigScreenMixins],
        data() {
            const themeColorConfig = {
                "presetApi": {
                    "getClassifyOne": "",
                    "getClassifyTow": "",
                    "getClassifyShop": ""
                },
                "themeType": 0,
                "themeConfig": [{
                    "colorConfig": ["#333333", "#666666", "#999999", "#ffffff", "#0052c7", "#F02325", "#FC9C3A", "#4DC777", "#F2CC98", "#F2CC66"],
                    "bgColorConfig": ["#EBEDF8", "#FFFFFF", "#0052c7", "#FC9C3A", "#FC9fff", "#E6F333", "#E6F1FE", "linear-gradient(301deg, #EBBA7B 0%, #F8D9AD 100%)", "linear-gradient(180deg, #F5588E 0%, #F0403C 100%)", "linear-gradient(179deg, #FFD033 0%, #F4890E 100%)"],
                    "bdColorConfig": ["#EBEDF8", "#FFFFFF", "#0052c7", "#FC9C3A", "#333333", "#666666", "#999999", "#dddddd", "#1178F0", "#F02325"]
                }]
            };
            receive(this);
            receiveNew(this);
            return {
                themeColorConfig,
                mapdata: mapdata,
                "isFullScreen": false,
                "big_screen_global_query": {
                    "screen_global_time_range_type": "5",
                    "screen_global_time_custom_time": "",
                    "screen_global_dept": "",
                    "screen_global_user": "",
                    "diy_api_time": ""
                },
                "saizhuge_api_loaded": false,
                "weather_info": {},
                "weather_data": [{
                    "name": "晴",
                    "code": "0",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/37eee88f67459de75005cc6a409e08c9.png"
                }, {
                    "name": "夜晚晴",
                    "code": "1",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/def19f13e5e2779dcaf11446b5ff6c57.png"
                }, {
                    "name": "晴",
                    "code": "2",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/37eee88f67459de75005cc6a409e08c9.png"
                }, {
                    "name": "夜晚晴",
                    "code": "3",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/def19f13e5e2779dcaf11446b5ff6c57.png"
                }, {
                    "name": "多云",
                    "code": "4",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/937ea42d4d54677a960419fc926d2308.png"
                }, {
                    "name": "晴间多云",
                    "code": "5",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2be9d1715692cdf209f7f56f85bb5aa7.png"
                }, {
                    "name": "晴间多云",
                    "code": "6",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2be9d1715692cdf209f7f56f85bb5aa7.png"
                }, {
                    "name": "大部多云",
                    "code": "7",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/8c1710ce88d626dad374865cc5cc285d.png"
                }, {
                    "name": "大部多云",
                    "code": "8",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/8e47c4a733b6ea39aa94ea362bc942fa.png"
                }, {
                    "name": "阴",
                    "code": "9",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/b8a945d068a4c968e5c05e023a67571f.png"
                }, {
                    "name": "阵雨",
                    "code": "10",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2987ff71ec8f90fdffa1c0114e13b1f9.png"
                }, {
                    "name": "雷阵雨",
                    "code": "11",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/751a274ee37d368cd45471edc5b35411.png"
                }, {
                    "name": "雷阵雨伴有冰雹",
                    "code": "12",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/2c7657970388a04e29049a23a0046c56.png"
                }, {
                    "name": "小雨",
                    "code": "13",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/6b02916ef905c0f100e3e6d4bf4c4ff0.png"
                }, {
                    "name": "中雨",
                    "code": "14",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/cc26fd0d1cda78eda4b53d85718b8803.png"
                }, {
                    "name": "大雨",
                    "code": "15",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/1598c140199a349d9ec4aed4482f0cf1.png"
                }, {
                    "name": "暴雨",
                    "code": "16",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/5868a1d8b7bc890f8b7d15df67095c4a.png"
                }, {
                    "name": "大暴雨",
                    "code": "17",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/b460fe42bb0e8dcbc177b5d6ef5b3c30.png"
                }, {
                    "name": "特大暴雨",
                    "code": "18",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/5868a1d8b7bc890f8b7d15df67095c4a.png"
                }, {
                    "name": "冻雨",
                    "code": "19",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/121096065da289cc9ebf23c778c8a4e8.png"
                }, {
                    "name": "雨夹雪",
                    "code": "20",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d9c47f9707616842680ba38e1c8e4d43.png"
                }, {
                    "name": "阵雪",
                    "code": "21",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/af6e554f62f546c76b3b495df7f36eb2.png"
                }, {
                    "name": "小雪",
                    "code": "22",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/71744d3bd3230b10f5d09666a76657ea.png"
                }, {
                    "name": "中雪",
                    "code": "23",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/a29d1ac31de2a2cdaecfb4c579cdf928.png"
                }, {
                    "name": "大雪",
                    "code": "24",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/62145c7aea6a3e65c5f1dc8d84f5c92d.png"
                }, {
                    "name": "暴雪",
                    "code": "25",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/50946c87ed7c0e4c471d7cb0310115c3.png"
                }, {
                    "name": "浮尘",
                    "code": "26",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/46258a78adc3acf03d0186836e89b798.png"
                }, {
                    "name": "扬沙",
                    "code": "27",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/a2440c63509d48eb1fa45804c6476f7d.png"
                }, {
                    "name": "沙尘暴",
                    "code": "28",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/9a80471d8001ea814aa4206d3feda602.png"
                }, {
                    "name": "强沙尘暴",
                    "code": "29",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/da4066fc0584850d72ec402894765b2d.png"
                }, {
                    "name": "雾",
                    "code": "30",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/4cf7128b075acfd65af6ea175f7240ce.png"
                }, {
                    "name": "霾",
                    "code": "31",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/c6325f4ef718e9aef9dbff86e2d28817.png"
                }, {
                    "name": "风",
                    "code": "32",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/dccb4227577c4f0e51c6b9b16fa75af1.png"
                }, {
                    "name": "大风",
                    "code": "33",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/b1d9445881a4a9d0b1471f831d3800c8.png"
                }, {
                    "name": "飓风",
                    "code": "34",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d58120ad96b2b4df9f4ffb35dc07c3c7.png"
                }, {
                    "name": "热带风暴",
                    "code": "35",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/3ca919f2ae75739b3196460dfffdd405.png"
                }, {
                    "name": "龙卷风",
                    "code": "36",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/785316e069cc774d7a540625f82b7973.png"
                }, {
                    "name": "冷",
                    "code": "37",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/785316e069cc774d7a540625f82b7973.png"
                }, {
                    "name": "热",
                    "code": "38",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d33c81b9f8772998d9bba7d3ea52acb0.png"
                }, {
                    "name": "未知",
                    "code": "99",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/db353a99b557f85968a262210c69f0d7.png"
                }],
                "viewSource": "PC",
                "big_screen_global_config": {
                    "is_screen_global_time": false,
                    "is_screen_global_dept": false,
                    "is_screen_global_user": false
                },
                "designWidth": 1920,
                "designHeight": 1080,
                "calculateStyles": {},
                "screenWidth": window.innerWidth,
                "screenHeight": window.innerHeight,
                "timerW": false,
                "timerH": false,
                "page_scale": 1,
                "theme_color_7982": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
                "chartOptions_random_3375": {
                    "tooltip": {
                        "trigger": "axis",
                        "axisPointer": {
                            "type": "shadow"
                        },
                        "textStyle": {
                            "color": "inherit",
                            "fontSize": 14
                        }
                    },
                    "legend": {
                        "type": "scroll",
                        "textStyle": {
                            "color": "#fff"
                        },
                        "show": true,
                        "orient": "horizontal",
                        "left": "center",
                        "top": ""
                    },
                    "grid": {
                        "left": "1%",
                        "right": "2%",
                        "bottom": "0%",
                        "top": "15%",
                        "containLabel": true
                    },
                    "xAxis": {
                        "type": "category",
                        "axisTick": {
                            "show": true
                        },
                        "axisLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        },
                        "axisLabel": {
                            "show": true,
                            "color": "#fff",
                            "fontSize": 12,
                            "fontWeight": 400,
                            "rotate": 0
                        },
                        "splitLine": {
                            "show": false,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        }
                    },
                    "yAxis": {
                        "type": "value",
                        "axisTick": {
                            "show": false
                        },
                        "axisLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        },
                        "axisLabel": {
                            "show": true,
                            "color": "#fff",
                            "fontSize": 12,
                            "fontWeight": 400
                        },
                        "splitLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        }
                    },
                    "seriesSetting": {
                        "markPoint": {
                            "label": {
                                "normal": {
                                    "textStyle": {
                                        "color": "#fff",
                                        "fontSize": 14,
                                        "fontWeight": 400
                                    }
                                }
                            },
                            "itemStyle": [],
                            "data": [],
                            "symbol": "pin",
                            "symbolSize": 50
                        },
                        "markLine": {
                            "data": [],
                            "lineStyle": {
                                "type": "dashed"
                            },
                            "label": {
                                "color": "#fff"
                            },
                            "symbol": "none"
                        },
                        "label": {
                            "normal": {
                                "show": false,
                                "position": "top",
                                "fontSize": 14,
                                "color": "inherit"
                            }
                        }
                    }
                },
                "field_options_569372": {
                    "xAxis": {
                        "data": ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00"]
                    },
                    "series": [{
                        "name": "订单取消率",
                        "data": [320, 340, 359, 375, 380, 390, 400],
                        "type": "line"
                    }, {
                        "name": "订单退款率",
                        "data": [200, 20, 90, 65, 90, 50, 80],
                        "type": "line"
                    }]
                }, // 售后分析折线图
                "theme_color_2141": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
                "chartOptions_random_3271": {
                    "tooltip": {
                        "show": true,
                        "autoToolTip": false,
                        "trigger": "axis",
                        "axisPointer": {
                            "type": "shadow"
                        },
                        "textStyle": {
                            "color": "inherit",
                            "fontSize": 14
                        }
                    },
                    "legend": {
                        "type": "scroll",
                        "textStyle": {
                            "color": "#fff"
                        },
                        "show": true,
                        "orient": "horizontal",
                        "left": "center",
                        "top": ""
                    },
                    "grid": {
                        "left": "2%",
                        "right": "2%",
                        "bottom": "0%",
                        "top": "15%",
                        "containLabel": true
                    },
                    "xAxis": {
                        "type": "category",
                        "axisTick": {
                            "show": true
                        },
                        "axisLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        },
                        "axisLabel": {
                            "show": true,
                            "color": "#fff",
                            "fontSize": 12,
                            "fontWeight": 400,
                            "rotate": 0
                        },
                        "splitLine": {
                            "show": false,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        }
                    },
                    "yAxis": {
                        "type": "value",
                        "axisTick": {
                            "show": false
                        },
                        "axisLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        },
                        "axisLabel": {
                            "show": true,
                            "color": "#fff",
                            "fontSize": 12,
                            "fontWeight": 400
                        },
                        "splitLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        }
                    },
                    "barSetting": {
                        "barWidth": 16,
                        "markPoint": {
                            "label": {
                                "normal": {
                                    "textStyle": {
                                        "color": "#fff",
                                        "fontSize": 14,
                                        "fontWeight": 400
                                    }
                                }
                            },
                            "itemStyle": [],
                            "data": [],
                            "symbol": "pin",
                            "symbolSize": 50
                        },
                        "label": {
                            "normal": {
                                "show": true,
                                "position": "right",
                                "fontSize": 16,
                                "color": "#fff"
                            }
                        },
                        "itemStyle": {
                            "borderRadius": [5, 5, 5, 5]
                        },
                        "markLine": {
                            "label": {
                                "color": "#fff"
                            },
                            "symbol": "none",
                            "lineStyle": {
                                "type": "dashed"
                            },
                            "data": []
                        },
                        "barGap": "0%"
                    }
                },
                refundAmountLine: {
                    "xAxis": {
                        "data": ["00:00", "01:00", "02:00", "03:00", "04:00"]
                    },
                    "series": [{
                        "name": "售后单数",
                        "data": [320, 340, 359, 375, 380],
                        "type": "bar"
                    }, {
                        "name": "售后金额",
                        "data": [200, 20, 90, 65, 90],
                        "type": "bar"
                    }]
                },
                "theme_color_8123": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
                goodsRankList: {
                    "columns": [{
                        "name": "商品名称",
                        "prop": "shopname" //
                    }, {
                        "name": "购买数量",
                        "prop": "shopnum"
                    }, {
                        "name": "商品总金额",
                        "prop": "allprice"
                    }, {
                        "name": "已售后金额",
                        "prop": "shouprice"
                    }],
                    "rows": [{
                        "shopname": "apple手机",
                        "shopnum": 120,
                        "allprice": 12000,
                        "shouprice": 6502
                    }, {
                      "shopname": "apple手机",
                      "shopnum": 120,
                      "allprice": 12000,
                      "shouprice": 6502
                    }, {
                      "shopname": "apple手机",
                      "shopnum": 120,
                      "allprice": 12000,
                      "shouprice": 6502
                    }]
                }, // 实时订单
                "theme_color_8560": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
                "chartOptions_random_4677": {
                    "tooltip": {
                        "trigger": "axis",
                        "axisPointer": {
                            "type": "shadow"
                        },
                        "textStyle": {
                            "color": "inherit",
                            "fontSize": 14
                        }
                    },
                    "legend": {
                        "type": "scroll",
                        "textStyle": {
                            "color": "#fff"
                        },
                        "show": true,
                        "orient": "horizontal",
                        "left": "center",
                        "top": "",
                        "symbol_icon": "roundRect",
                        "icon": "roundRect"
                    },
                    "grid": {
                        "left": "1%",
                        "right": "2%",
                        "bottom": "0%",
                        "top": "15%",
                        "containLabel": true
                    },
                    "xAxis": {
                        "type": "category",
                        "axisTick": {
                            "show": true
                        },
                        "axisLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        },
                        "axisLabel": {
                            "show": true,
                            "color": "#fff",
                            "fontSize": 12,
                            "fontWeight": 400,
                            "rotate": 0
                        },
                        "splitLine": {
                            "show": false,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        }
                    },
                    "yAxis": {
                        "type": "value",
                        "axisTick": {
                            "show": false
                        },
                        "axisLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        },
                        "axisLabel": {
                            "show": true,
                            "color": "#fff",
                            "fontSize": 12,
                            "fontWeight": 400
                        },
                        "splitLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        }
                    },
                    "seriesSetting": {
                        "markPoint": {
                            "label": {
                                "normal": {
                                    "textStyle": {
                                        "color": "#fff",
                                        "fontSize": 14,
                                        "fontWeight": 400
                                    }
                                }
                            },
                            "itemStyle": [],
                            "data": [],
                            "symbol": "pin",
                            "symbolSize": 50
                        },
                        "markLine": {
                            "data": [],
                            "lineStyle": {
                                "type": "dashed"
                            },
                            "label": {
                                "color": "#fff"
                            },
                            "symbol": "none"
                        },
                        "label": {
                            "normal": {
                                "show": false,
                                "position": "top",
                                "fontSize": 14,
                                "color": "#fff"
                            }
                        }
                    }
                },
                orderAmountLine: {
                    "xAxis": {
                        "data": ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00"]
                    },
                    "series": [{
                        "name": "下单量",
                        "data": [320, 340, 359, 375, 380, 390, 400],
                        "type": "line"
                    }, {
                        "name": "支付数",
                        "data": [200, 20, 90, 65, 90, 50, 80],
                        "type": "line"
                    }, {
                        "name": "付款金额",
                        "data": [32, 34, 35, 37, 38, 30, 40],
                        "type": "line"
                    }]
                }, // 今日销量
                payRate: {
                    "data": 98.6
                }, // 下单支付率
                orderUserCountToday: {
                    "data": 43321
                }, // 付款客户
                orderCountToday: {
                    "data": 99.5
                }, // 付款单量
                goodsCountToday: {
                    "data": 2331
                }, // 下单数
                orderCount: {
                    "data": 31
                }, // 客单价
                customerPrice: {
                    "data": 44
                }, // 均单价
                payAmount: {
                    "data": 32
                }, // 销售额
                "field_options_370833": {
                    "data": 43
                }, // 访客数
                "field_options_427808": {
                    "data": 32
                }, // 成交客户
                goodsViewCount: {
                    "data": 65
                },
                goodsCount: {
                    "data": 45
                }, // 成交商品
                "theme_color_5461": ["#3EDCE0", "#1A7EEF", "#8A59FA", "#FA577E", "#FBB26E"],
                orderAddressMap: {
                    "map_value": [{
                        "位置": "北京市", // 城市
                        "记录数量": 1,
                    }, {
                        "位置": "河北省",
                        "记录数量": 1,
                    }, {
                        "位置": "内蒙古自治区",
                        "记录数量": 1,
                    }, {
                        "位置": "新疆维吾尔自治区",
                        "记录数量": 1,
                    }],
                    "columns": ["位置", "记录数量"], // 固定不动
                    "position": "china",
                    "region_code": ""
                }, // 地域分布
                "theme_color_8404": ["#FF8C19", "#8B36FF", "#FF5226", "#FBF800", "#0DFBE2", "#206EEA", "#0F36A2", "#FC658A"],
                "chartOptions_random_1923": {
                    "seriesSetting": {
                        "center": ["50%", "50%"],
                        "radius": ["48%", "65%"],
                        "itemStyle": {
                            "borderColor": "",
                            "borderWidth": "",
                            "borderRadius": ""
                        },
                        "startAngle": "",
                        "type": "pie",
                        "label": {
                            "color": "#f40"
                        }
                    },
                    "labelSetting": {
                        "label": {
                            "color": "#fff",
                            "show": false,
                            "emphasis": {
                                "show": true,
                                "textStyle": {
                                    "fontSize": 14,
                                    "color": "#fff"
                                },
                                "rich": {
                                    "a": {
                                        "fontSize": 14
                                    }
                                }
                            }
                        },
                        "labelLine": {
                            "show": false
                        }
                    },
                    "legend": {
                        "type": "scroll",
                        "icon": "circle",
                        "textStyle": {
                            "color": "#fff",
                            "fontSize": 16
                        },
                        "show": false,
                        "orient": "vertical",
                        "left": "73%",
                        "top": "middle"
                    },
                    "tooltip": {
                        "show": true,
                        "autoToolTip": true,
                        "trigger": "item",
                        "axisPointer": {
                            "type": "shadow"
                        },
                        "textStyle": {
                            "color": "rgba(255, 255, 255, 1)",
                            "fontSize": 15
                        },
                        "backgroundColor": "rgba(0, 0, 0, 0.8)",
                        "borderColor": "rgba(255, 0, 0, 0)"
                    }
                },
                catePie: {
                    "series": [{
                        "data": [{
                            "value": 1335,
                            "name": "机电学院"
                        }, {
                            "value": 1310,
                            "name": "艺术学院"
                        }, {
                            "value": 1234,
                            "name": "新闻学院"
                        }, {
                            "value": 1350,
                            "name": "医学院"
                        }, {
                            "value": 1548,
                            "name": "法学院"
                        }, {
                            "value": 1987,
                            "name": "商学院"
                        }]
                    }]
                }, // 商品分类占比
                orderAmount: {
                    "data": 2211
                }
            };

        },
        filters: {},
        created() {
            if (getUrlKey('viewSource')) {
                this.viewSource = getUrlKey('viewSource');
            }
          this.getHomeAllStatistics();
          this.getHomeTodayStatistics()
          //商品分类占比
          this.getCatePie()
          this.getGoodsResult()
          this.getAmountChart()
          this.getGoodsRank()
          this.getUserAddressOrder()

        },
        mounted() {

            let that = this;
            window.onresize = () => {
                that.screenWidth = that.$refs.antdVue.offsetWidth
                that.screenHeight = that.$refs.antdVue.offsetHeight
                that.handleResize();
            }
            this.$nextTick(() => {
                that.handleResize();
            })
        },
        computed: {

        },
        watch: {
            screenWidth(val) {
                if (!this.timerW) {
                    let that = this;
                    // that.screenWidth = val;
                    this.timerW = true;
                    that.handleResize();
                    setTimeout(function() {
                        that.timerW = false;
                    }, 400)
                }
            },
            screenHeight(val) {
                if (!this.timerH) {
                    let that = this;
                    // that.screenHeight = val;
                    this.timerH = true;
                    that.handleResize();
                    setTimeout(function() {
                        that.timerH = false;
                    }, 400)
                }
            }
        },
        methods: {
          moment,
            copyText,
            mixinTableItemChange,
            in_array,
            themeColorInit,
            isEmpty,
            //统一获取自定义接口
            get_diy_api_page() {

            },
          getHomeAllStatistics() {
            homeAllResult({}).then(response => {
              this.payAmount = {data: response.data.payAmount}
              this.orderAmount = {data: response.data.orderAmount}
              this.goodsCount = {data: response.data.goodsCount}
              this.orderCount = {data: response.data.orderCount}
              this.customerPrice = {data: response.data.customerPrice}


            });
          },

          getHomeTodayStatistics() {
            homeResult({}).then(response => {
              this.goodsCountToday = {data: response.data.today.goodsCount}
              this.orderCountToday = {data: response.data.today.orderCount}
              this.payRate = {data: response.data.today.payRate}
              this.orderUserCountToday = {data: response.data.today.orderCount}

            });
          },

          getCatePie() {
            goodsCateAmountPie().then(response => {
              this.catePie={"series": [{"data": response.data}] }
            })
          },

          getGoodsResult() {
            goodsResult({}).then(response => {
              this.goodsViewCount = {data: response.data.clicksNum}
            })
          },

          getAmountChart() {
            let orderAmountParam = {
              chartType: 'hours',
              dateRange: [],
              startTime: undefined,
              endTime: undefined,
            }
            orderAmountChart(orderAmountParam).then(response => {
              this.goodsCountChart = {
                xAxis: {
                  data: response.data.xxAxis
                },
                series: [{
                  name: "累计数量",
                  data: response.data.yyAxis.goodsCountList || [],
                  type: "line"
                }]
              }
              this.orderAmountLine = {
                  xAxis: {
                    data: response.data.xxAxis
                  },
                  series: [{
                    "name": "下单量",
                    "data": response.data.yyAxis.goodsCountList || [],
                    "type": "line"
                  }, {
                    "name": "支付量",
                    "data": response.data.yyAxis.orderCountList || [],
                    "type": "line"
                  }, {
                    "name": "付款金额",
                    "data": response.data.yyAxis.payAmountList || [],
                    "type": "line"
                  }]
                }
              this.refundAmountLine={
                xAxis: {
                  data: response.data.xxAxis
                },
                series: [{
                  "name": "售后单数",
                  "data": response.data.yyAxis.refundCountList || [],
                  "type": "bar"
                }, {
                  "name": "售后金额",
                  "data": response.data.yyAxis.refundAmountList || [],
                  "type": "bar"
                }]
              }
            })
          },
          getUserAddressOrder() {
            //三个月的
            let addressOrderParam = {
              dateRange: [],
              startTime: moment().subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss'),
              endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            }
            userAddressOrder(addressOrderParam).then((res) => {
              const rows = res.data.map(item => ({
                // 商品名称
                '位置': item.name,
                // 购买数量
                '记录数量': item.value,
              }));
              this.orderAddressMap = {
                map_value: rows,
                columns: ["位置", "记录数量"], // 固定不动
                position: "china",
                region_code: ""
              }
            });
          },


          getGoodsRank() {
            let queryParam = {
              id: undefined,
              isPay: true,
              createBeginTime: moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss'),
              createEndTime: moment().format('YYYY-MM-DD HH:mm:ss'),
              pageNum: 1,
              pageSize: 10,
              sortField:'payAmount',
              sortOrder: 'desc'
            };
            pageGoods(queryParam).then(response => {
              const records = response.data.records || []; //列表
              //records .转换成 goodsRankList 中对应的数据格式
              const rows = records.map(item => ({
                // 商品名称
                shopname: item.goodsName,
                // 购买数量
                shopnum: item.goodsCount,
                // 商品总金额（按需要可改为 item.payAmount）
                allprice: item.goodsAmount,
                // 已售后金额
                shouprice: item.refundAmount
              }));
              this.goodsRankList = {
                columns: [{
                  "name": "商品名称",
                  "prop": "shopname" //
                }, {
                  "name": "购买数量",
                  "prop": "shopnum"
                }, {
                  "name": "商品总金额",
                  "prop": "allprice"
                }, {
                  "name": "已售后金额",
                  "prop": "shouprice"
                }],
                rows: rows
              }
            });
          },

            handleResize() {
                let that = this;
                this.$nextTick(() => {
                    that.screenWidth = that.$refs.antdVue.offsetWidth
                    that.screenHeight = that.$refs.antdVue.offsetHeight
                    let screenWidth = that.screenWidth;
                    let screenHeight = that.screenHeight;
                    let scale = Math.min(screenWidth / this.designWidth, screenHeight / this.designHeight);
                    let horizontalOffset = (screenWidth - this.designWidth * scale) / 2;
                    that.calculateStyles = {
                        transformOrigin: 'top left',
                        transform: `translateX(${horizontalOffset}px)  scale(${scale}) `,
                    };
                });
            }

        }
    }
</script>
<style lang="less" scoped>
    /* External CSS is loaded in index.html to prevent style flickering */
    @import '../../assets/diypaaspc/diy-pass-big-screen.css';
    @import '../../assets/diypaaspc/library-ant-design-vue.css';

    .antdVue {
        position: relative;
        width: 100%;
        width: 1920px;
        height: 1080px;
        overflow-y: hidden;
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240311/d9e57c513f7aa8c8b7a1f0505ec17088.png) no-repeat;
        background-size: 100% 100% !important;
        background-position: center center;
    }

    .zoom_bg_color {
        background: rgba(2, 8, 15, 0);
    }

    #antdVue .gongzuotaiwai_987_random_flex_0 {
        background-position: 0px 10px;
    }

    #antdVue .gongzuotaiwai_473_random_fd0_1_c2_c0_c1_c2_c0 {
        height: 180px;
    }

    #antdVue .gongzuotaiwai_231_fd0_1_c2_c0_c1 {
        background: rgba(0, 14, 54, .7);
        border-radius: 8px;
        height: 442px;
        padding: 16px;
    }

    #antdVue .gongzuotaiwai_654_fd0_1_c2_c0_c0_c2_c0_c0_c0 {
        max-width: 20px;
        max-height: 20px;
    }

    #antdVue .gongzuotaiwai_568_random_fd0_1_c2_c0_c0_c2_c0 {
        text-align: left;
        --header-bg: transparent;
        --header-text-color: rgb(255, 255, 255);
        --header-text-font-size: 16px;
    }
    #antdVue .gongzuotaiwai_568_random_fd0_1_c2_c0_c0_c2_c0 .new-custom-table-header-item {
        padding: 0 8px !important;
        flex-shrink: 0 !important;
        min-width: 60px;
    }
    #antdVue .gongzuotaiwai_568_random_fd0_1_c2_c0_c0_c2_c0 .new-custom-table-header > div:first-child {
        padding: 0 8px !important;
        flex-shrink: 0 !important;
    }

    #antdVue .gongzuotaiwai_327_fd0_1_c2_c0_c0 {
        background: rgba(0, 14, 54, .7);
        border-radius: 8px;
        margin: 0px 0px 24px 0px;
        height: 442px;
        padding: 16px;
    }

    #antdVue .gongzuotaiwai_431_random_fd0_1_c1_c0_c1_c3_c0 {
        height: 210px;
    }

    #antdVue .gongzuotaiwai_209_fd0_1_c1_c0_c1_c2_c3 {
        background: rgba(38, 95, 255, .1);
        font-family: PingFang SC, PingFang SC;
        border-radius: 8px;
    }

    #antdVue .gongzuotaiwai_842_fd0_1_c1_c0_c1_c2_c0_c1_c1 {
        color: #11F6F2;
        font-family: PangMenZhengDaoBiaoTiTiMianFeiBan-2;
        margin: 0px 0px -9px 0px;
    }

    #antdVue .gongzuotaiwai_895_random_fd0_1_c1_c0_c1_c2_c0_c1_c0 {
        color: #11F6F2;
        font-family: PangMenZhengDaoBiaoTiTiMianFeiBan-2;
    }

    #antdVue .gongzuotaiwai_127_fd0_1_c1_c0_c1_c2_c0 {
        background: rgba(38, 95, 255, .1);
        font-family: PingFang SC, PingFang SC;
        margin: 0px 9px 0px 0px;
        border-radius: 8px;
    }

    #antdVue .gongzuotaiwai_813_fd0_1_c1_c0_c1_c2 {
        height: 88px;
        margin: 0px 0px 16px 0px;
        min-height: 88px;
    }

    #antdVue .gongzuotaiwai_228_fd0_1_c1_c0_c1 {
        background: rgba(0, 14, 54, .7);
        height: 442px;
        padding: 16px;
        border-radius: 8px;
        margin: -34px 0px 0px 0px;
    }

    #antdVue .gongzuotaiwai_570_fd0_1_c1_c0_c0_c0_c2 {
        font-weight: 800;
        font-family: Source Han Sans CN, Source Han Sans CN;
        text-shadow: 0px 3px 5px #090A1F;
        top: 280px;
    }

    #antdVue .gongzuotaiwai_838_fd0_1_c1_c0_c0_c0_c1 {
        height: 104px;
    }

    #antdVue .gongzuotaiwai_623_random_fd0_1_c1_c0_c0_c0_c0_c0_c0 {
        line-height: 21px;
        font-weight: 800;
        font-family: Source Han Sans CN, Source Han Sans CN;
        text-shadow: 0px 3px 5px rgba(7, 24, 93, 0.3);
    }

    #antdVue .gongzuotaiwai_233_fd0_1_c1_c0_c0_c0_c0_c0 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240301/1fc5bb12ea2fedc81e2c5f47c5244fbc.png) no-repeat;
        width: 104px;
    }

    #antdVue .gongzuotaiwai_777_fd0_1_c1_c0_c0_c0_c0 {
        height: 104px;
        padding: 0px 100px 0px 100px;
    }

    #antdVue .gongzuotaiwai_610_fd0_1_c1_c0_c0 {
        height: 500px;
    }

    #antdVue .gongzuotaiwai_791_random_fd0_1_c0_c0_c1_c2_c0 {
        height: 350px;
    }

    #antdVue .gongzuotaiwai_633_fd0_1_c0_c0_c1_c1 {
        height: 4px;
        border-radius: 0px 0px 0px 0px;
        margin: 0px 0px 16px 0px;
        min-height: 4px;
    }

    #antdVue .gongzuotaiwai_510_fd0_1_c0_c0_c1_c0 {
        font-weight: 800;
        font-family: Source Han Sans SC, Source Han Sans SC;
        margin: 0px 0px 16px 0px;
    }

    #antdVue .gongzuotaiwai_247_fd0_1_c0_c0_c1 {
        background: rgba(0, 14, 54, .7);
        height: 442px;
        margin: 24px 0px 0px 0px;
        padding: 16px;
        border-radius: 8px;
    }

    #antdVue .gongzuotaiwai_832_fd0_1_c0_c0_c0_c2_c1_c1 {
        font-family: Source Han Sans SC, Source Han Sans SC;
    }

    #antdVue .gongzuotaiwai_380_random_fd0_1_c0_c0_c0_c2_c1_c0 {
        line-height: 25px;
        font-weight: 800;
        font-family: Source Han Sans CN, Source Han Sans CN;
        text-shadow: 0px 3px 5px rgba(7, 24, 93, 0.3);
    }

    #antdVue .gongzuotaiwai_830_fd0_1_c0_c0_c0_c2_c1 {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 99;
    }

    #antdVue .gongzuotaiwai_906_fd0_1_c0_c0_c0_c2_c0 {
        width: 240px;
        height: 240px;
        border-radius: 0px 0px 0px 0px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    #antdVue .gongzuotaiwai_237_fd0_1_c0_c0_c0_c1_c0 {
        height: 4px;
        border-radius: 0px 0px 0px 0px;
        min-height: 4px;
    }

    #antdVue .gongzuotaiwai_278_fd0_1_c0_c0_c0_c1 {
        margin: 16px 0px 0px 0px;
        border-radius: 8px;
    }

    #antdVue .gongzuotaiwai_918_fd0_1_c0_c0_c0_c0_c0 {
        font-weight: 800;
        font-family: Source Han Sans SC, Source Han Sans SC;
        line-height: 0px;
    }

    #antdVue .gongzuotaiwai_967_fd0_1_c0_c0_c0_c0 {
        height: 38.46px;
        max-width: 403px;
    }

    #antdVue .gongzuotaiwai_845_fd0_1_c0_c0_c0 {
        background: rgba(0, 14, 54, .5);
        padding: 16px;
        height: 442px;
        border-radius: 8px;
    }

    #antdVue .gongzuotaiwai_943_random_fd0_0_c5 {
        width: 70px;
        height: 70px;
        --full-screen-color: rgba(255, 255, 255, 1);
        --full-screen-width: 35px;
        --full-screen-height: 35px;
        top: 28px;
        right: 100px;
        z-index: 99;
    }

    #antdVue .gongzuotaiwai_596_random_fd0_0_c4_c1 {
        color: rgba(255, 255, 255, 1);
    }

    #antdVue .gongzuotaiwai_787_fd0_0_c4_c0 {
        width: 32px;
        height: 32px;
        border-radius: 0px 0px 0px 0px;
        margin: 0px 8px 0px 0px;
    }

    #antdVue .gongzuotaiwai_300_fd0_0_c4 {
        width: 300px;
        top: 38px;
        right: 180px;
        height: 50px;
    }

    #antdVue .gongzuotaiwai_912_fd0_0_c3 {
        width: 48px;
        height: 48px;
        border-radius: 0px 0px 0px 0px;
        margin: 0px 0px 0px 8px;
    }

    #antdVue .gongzuotaiwai_465_fd0_0_c1 {
        width: 48px;
        height: 48px;
        margin: 0px 8px 0px 0px;
    }

    #antdVue .gongzuotaiwai_432_fd0_0_c0_c3 {
        margin: 0px 0px 0px 8px;
        line-height: 10px;
    }

    #antdVue .gongzuotaiwai_407_fd0_0_c0_c2 {
        background: linear-gradient(180deg, rgba(216, 226, 255, 0) 0%, #E3EAFF 49%, rgba(216, 226, 255, 0) 100%);
        width: 2px;
        height: 16px;
        margin: 0px 0px 0px 8px;
    }

    #antdVue .gongzuotaiwai_458_fd0_0_c0_c1 {
        margin: 0px 0px 0px 8px;
    }

    #antdVue .gongzuotaiwai_863_fd0_0_c0_c0 {
        width: 32px;
        height: 32px;
        border-radius: 0px 0px 0px 0px;
    }

    #antdVue .gongzuotaiwai_118_fd0_0_c0 {
        top: 38px;
        left: 82px;
        height: 50px;
    }

    #antdVue .gongzuotaiwai_810_fd0_0 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240124/95867b2fe8e71f9cd1cf14259ed09824.png) no-repeat;
        font-size: 48px;
        height: 135px;
        font-weight: 800;
    }

    .zoom_bg_color {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240311/ec4f1c64f89fb860d494f6e5d5da68a2.png) center center / 100% 101% no-repeat !important;
        overflow: hidden
    }
</style>